// extracted by mini-css-extract-plugin
module.exports = {"tdStyle":"tdStyle--3toIk"};